import { Loader2 } from 'lucide-react';

const SIZE_CLASS = {
  xs: 'h-3 w-3',
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
  xl: 'h-6 w-6',
  '2xl': 'h-7 w-7',
  '3xl': 'h-8 w-8',
} as const;

export type LoadingSpinnerSize = keyof typeof SIZE_CLASS;

export function LoadingSpinner({
  size = 'md',
  className,
}: {
  size?: LoadingSpinnerSize;
  className?: string;
}) {
  return (
    <Loader2
      className={`animate-spin ${SIZE_CLASS[size]}${className ? ` ${className}` : ''}`}
      aria-hidden
    />
  );
}

/** Full content pane: CSS ring like the old calendar/Plantafel loader. */
export function PageLoadingState() {
  return (
    <div className="flex h-full min-h-0 flex-1 items-center justify-center" role="status">
      <div
        className="h-10 w-10 animate-spin rounded-full border-b-2 border-pipedrive-blue"
        aria-hidden
      />
      <span className="sr-only">Wird geladen</span>
    </div>
  );
}

/** Nested region: gray spinner plus status text. */
export function InlineLoadingState({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <div
      role="status"
      className={`flex items-center justify-center gap-2 text-sm text-app-text-subtle ${className ?? ''}`.trim()}
    >
      <LoadingSpinner className="shrink-0 text-app-text-subtle" />
      <span>{label}</span>
    </div>
  );
}
